define(function (require) {

    var _ = require('underscore');
    var lpUtils = require('utils/lpUtils');
    var BaseFilterViewController = require('web-agent-viewControllers/BaseFilterViewController');
    var DateTimeUtils = require('web-agent-utils/DateTimeUtils');
    var TimeFrameViewController = require('web-agent-components/TimeFrameViewController');


    var FilterTimeFrameViewController = BaseFilterViewController.extend({
        ControllerName: 'FilterTimeFrameViewController',
        NowKey: DateTimeUtils.NOW_KEY,

        LPViewMap: {
            timeFrameArea: ".filter_time_frame"
        },
        LPClassesMap: {
        },

        initialize: function (constructorData) {

            this.filterOptions = lpUtils.cloneObject(constructorData);
            this.filterOptions.setFocusHandler = this.setFocus;
            this.filterOptions.hidden = false;

            if (_.isNumber(constructorData.maxDaysDuration)) {
                this.filterOptions.maxDaysDuration = constructorData.maxDaysDuration;
            } else if (_.isNumber(constructorData.maxMonthsDuration)) {
                this.filterOptions.maxDaysDuration = DateTimeUtils.getLastMonthsDurationInDays(constructorData.maxMonthsDuration);
            } else {
                this.filterOptions.maxDaysDuration = 31;  //default
            }

            //this.filterUIData = lpUtils.cloneObject(defaultFilter);
            this.filterName = constructorData.filterName;

        },

        events: function () {
            //this.bindViewEvent({selector: this.LPViewMap.button, DOMEvent: "click", callback: this.buttonClicked});
        },

        render: function () {
            this.timeFrameVC = new TimeFrameViewController(this.filterOptions);
            this.addViewController({viewController: this.timeFrameVC, target: this.LPViewMap.filterArea});
            this.filterData = this.filterResetData = this.timeFrameVC.getUIData();
            this.onShow();
        }
    });

    FilterTimeFrameViewController.prototype.setFilter = function (queryData) {
        if (queryData) {
            if (typeof(queryData.startDate) !== "undefined") {
                this.filterData.startDate = DateTimeUtils.createDateFromLong(queryData.startDate);
            }
            if (typeof(queryData.endDate) !== "undefined") {
                if (queryData.endDate === this.NowKey) {
                    this.filterData.endDate = queryData.endDate;
                } else {
                    this.filterData.endDate = DateTimeUtils.createDateFromLong(queryData.endDate);
                    if (this.filterData.endDate.getDate && isNaN(this.filterData.endDate.getDate()))
                    //|| (DateTimeUtils.createDateFromLong(new Date())) - this.filterData.endDate < 30 * 60 * 1000)
                    {
                        this.filterData.endDate = this.NowKey;
                    }
                }
            }
        }

        BaseFilterViewController.prototype.setFilter.call(this);
    };

    /**
     *  On reset set to "now" and reset the buttons
     */
    FilterTimeFrameViewController.prototype.reset = function () {
        BaseFilterViewController.prototype.reset.call(this);
        this.updateFilterUI();
    };

    FilterTimeFrameViewController.prototype.submitFilter = function (isReset) {
        this.filterUIData = this.timeFrameVC.getUIData();
        BaseFilterViewController.prototype.submitFilter.call(this, isReset);
    };

    /**
     *  Set the filter according to the data in the filter
     */
    FilterTimeFrameViewController.prototype.updateFilterUI = function () {
        this.timeFrameVC.setUIData(lpUtils.cloneObject(this.filterUIData));
        this.timeFrameVC.refresh();
    };

    return FilterTimeFrameViewController;

});
